import axios from 'axios'

export default {
  getJobs ( params, callback, fallback ) {
    axios.get( '/jobs', { params } )
    .then(resp => {
      if ( typeof callback == 'function' ) {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      }
    })
    .catch(error => {
      if ( typeof fallback == 'function' ) {
        if(typeof(fallback) != 'undefined') fallback( error );
      }
    })
  },
  create ( data, callback, fallback ) {
    axios.post( '/jobs', data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  save ( jobId, data, callback, fallback ) {
    axios.post( '/jobs/' + jobId, data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  getComments ( jobId, params, callback, fallback ) {
    axios.get( '/jobs/' + jobId + '/comments', { params } )
    .then(resp => {
      if ( typeof callback == 'function' ) {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      }
    })
    .catch(error => {
      if(typeof(fallback) != 'undefined') fallback( error );
    })
  },
  addComment ( jobId, data, callback, fallback ) {
    axios.post( '/jobs/' + jobId + '/comments', data )
    .then(resp => {
      if ( typeof callback == 'function' ) {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      }
    })
    .catch(() => {
      if ( typeof fallback == 'function' ) {
        fallback();
      }
    })
  },
  deleteComment ( jobId, commentId, callback, fallback ) {
    axios.delete( '/jobs/' + jobId + '/comments/' + commentId )
      .then(resp => {
        if ( typeof callback == 'function' ) {
          callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
        }
      })
      .catch(() => {
        if ( typeof fallback == 'function' ) {
          fallback();
        }
      })
  },
  printJobs ( params, callback, fallback ) {
    axios.get('/jobs/pdf', {
      responseType: 'blob', // important
      params
    }).then(resp => {
      if ( typeof callback == 'function' )
        callback( resp );
    }).catch(error => {
      if ( typeof fallback == 'function' )
        fallback(error);
    });
  },
  deleteAttachment ( jobId, attachmentId, callback, fallback ) {
    axios.delete( '/jobs/' + jobId + '/attachments/' + attachmentId )
      .then(resp => {
        if ( typeof callback == 'function' ) {
          callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
        }
      })
      .catch(() => {
        if ( typeof fallback == 'function' ) {
          fallback();
        }
      })
  }
}
